import { render } from "./_name.html?vue&type=template&id=2749d7b4&ts=true"
import script from "./_name.vue?vue&type=script&lang=ts"
export * from "./_name.vue?vue&type=script&lang=ts"

import "./_name.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\mt7rk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__